<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('productLocation.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
	{ text: $t('home'), href: '/' },
	{
		text: $t('productLocation.pageTitle'),
		active: true,
	},
]" />
		</div>
		<ts-card>
			<ts-card-wrapper>
				<div class="d-flex justify-content-between">
					<div class="ts-flex ts-space-x-3">
						<ts-button outline color="info" @click.prevent="addNew">
							{{ $t('add_new') }}
						</ts-button>
						<ts-button outline color="info" @click.prevent="addProductLocation">
							{{ $t('productLocation.allProductLocation') }}
						</ts-button>
						<!-- <ts-button outline color="info" @click.prevent="deleteMultiple">
							{{ $t('productLocation.delete') }}
						</ts-button> -->
					</div>
					<div class="d-flex ts-space-x-3 ts-items-center">
						<ts-input v-model="search" v-tooltip="$t('productLocation.search')" :placeholder="$t('search')"
							style="width: 250px" class="inline-block" />
						<ts-filter ref="filter">
							<div class="row">
								<div class="col-md-12">
									<label class="">{{ $t('employeeProfile.branch') }}</label>
									<ts-branch-filter @filter="branchFilter" class="ts-w-full"></ts-branch-filter>
								</div>
							</div>
							<div class="row ts-mt-3">
								<div class="col-md-12">
									<label>{{ $t('productLocation.warehouse') }}</label>
									<ts-location-filter :isDefaultSelect="false" :showPlaceholder="false"
										@filter="locationFilter"></ts-location-filter>
								</div>
							</div>
							<div class="row ts-mt-4">
								<div class="col-md-12">
									<label>{{ $t('productLocation.category') }}</label>
									<a-select v-model="categoryId" :options="categories" :allowClear="true" @change="getGroup"
										class="ts-w-full"></a-select>
								</div>
							</div>
							<div class="row ts-mt-4">
								<div class="col-md-12">
									<label>{{ $t('productLocation.productGroup') }}</label>
									<a-select v-model="productGroupId" :allowClear="true" :options="groups" @change="fetchData()"
										class="ts-w-full"></a-select>
								</div>
							</div>
						</ts-filter>
					</div>
				</div>
			</ts-card-wrapper>
			<ts-table :columns="columns" :records="resources" :loading="loading" :showCheckbox="true"
				checkBoxValueField="product_location_id" @check-items="(v) => checkedItems = v" ref="tableProduct"
				:rowGroup="{ field: 'location_name_en', }">
				<template v-slot="{ record }">
					<td>{{ record.branch.branch_name_en }}</td>
					<td>{{ record.barcode }}</td>
					<td>{{ record.category_name_en }}</td>
					<td>{{ record.pro_group_name_en }}</td>
					<td class="ts-font-khmer">{{ record.product_name_kh }}</td>
					<td>{{ record.product_name_en }}</td>
					<td class="ts-text-center">
						<a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
							:cancel-text="$t('no')" @confirm="deleteRecord(record)">
							<a href="#" :disabled="record._deleting">
								<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
								<i class="fa fa-trash text-red" v-else></i>
							</a>
						</a-popconfirm>
					</td>
				</template>
			</ts-table>
			<div class="d-flex justify-content-end p-15">
				<ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
			</div>
			<a-modal v-model="all_product_location" :title="$t('productLocation.allProductLocation')"
				@ok="onAssignProductLocation" @cancel="onCancel" :okText="$t('save')" :confirmLoading="product_location_loading"
				:centered="true">
				<input v-model.trim="searchLocation" type="text" class="form-control"
					:placeholder="$t('productLocation.searchModalWarehouse')">
				<div style="max-height:500px" class="ts-border ts-rounded ts-overflow-scroll ts-p-3 ts-mt-3">
					<ts-checkbox v-model="isCheckAll" @change="checkAllLocation">{{ $t('productLocation.all')
}}</ts-checkbox>
					<ts-checkbox v-model="model.location_id" v-for="(location, index) in locationList" :value="location.value"
						:key="index">{{ location.label }}</ts-checkbox>
				</div>
				<div class="validate" v-if="errors.has('location_id')">
					{{ errors.first('location_id') }}
				</div>
			</a-modal>
		</ts-card>
	</div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'productLocation',
	data() {
		return {
			errors: new Errors(),
			loading: false,
			searchLocation: '',
			product_location_loading: false,
			all_product_location: false,
			categories: [],
			locations: [],
			checkedItems: [],
			groups: [],
			model: {
				product_id_list: [],
				location_id: [],
			}
		}
	},
	computed: {
		...mapState('product/location', ['resources', 'pagination']),
		isCheckAll: {
			get() {
				return this.model.location_id.length == this.locationList.length
			},
			set() { }
		},
		locationList() {
			return this.$store.state.product.location.locations
				.filter(l => this.searchLocation.split(' ').every(s => l.location_name_en.toLowerCase().includes(s.toLowerCase())))
				.map((el) => ({
					value: el.location_id,
					label: el.location_name_en,
				}))
		},
		search: {
			get() {
				return this.$store.state.product.location.search
			},
			set(newValue) {
				this.$store.commit('product/location/SET_SEARCH', newValue)
				this.$store.commit('product/location/RESET_CURRENT_PAGE')
			},
		},
		categoryId: {
			get() {
				return this.$store.state.product.location.category_id
			},
			set(newValue) {
				this.$store.commit('product/location/SET_CATEGORY_ID', newValue)
			},
		},
		productGroupId: {
			get() {
				return this.$store.state.product.location.pro_group_id
			},
			set(newValue) {
				this.$store.commit('product/location/SET_GROUP_ID', newValue)
			},
		},
		columns() {
			return [
				{ name: this.$t('productLocation.branchName') },
				{ name: this.$t('productLocation.barcode') },
				{ name: this.$t('productLocation.productCategory') },
				{ name: this.$t('productLocation.productGroup') },
				{ name: this.$t('productLocation.productNameKh') },
				{ name: this.$t('productLocation.productNameEn') },
				{ name: this.$t('actions'), style: 'text-align:center; width:80px' }
			]
		},
	},
	created() {
		this.getCategory()
	},
	methods: {
		...mapActions('product/location', ['getLocation']),
		fetchData(attributes) {
			this.loading = true
			this.$store
				.dispatch('product/location/fetch', { ...attributes })
				.then((response) => {
					this.loading = false
				})
				.catch((error) => {
					this.loading = false
					this.$toasted.error(error.message)
				})
		},
		getCategory() {
			this.$store.dispatch('product/location/getCategory').then(response => {
				this.categories = response.data.map(el => ({
					value: el.category_id,
					label: el.category_name_en
				}))
			})
		},
		locationFilter(value) {
			this.$store.commit('product/location/SET_LOCATION_ID', value)
			this.fetchData()
		},
		addNew() {
			this.$router.push({ name: 'product-location-create' })
		},
		branchFilter(value) {
			this.$store.commit('product/location/SET_BRANCH_ID', value)
			this.fetchData()
		},
		addProductLocation() {
			this.all_product_location = true
			this.model.location_id = []
		},
		deleteMultiple() {
			if (!this.checkedItems.length) {
				this.$toasted.error('Please select any dealers.')
				return
			}
			this.waiting = true
			this.$store
				.dispatch('product/location/deleteMultiple', {
					product_location_id: this.checkedItems
				})
				.then(response => {
					this.$toasted.success(response.message)
					this.$refs.tableProduct.checkedItems = []
					this.checkedItems = []
					this.fetchData()
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		onCancel() {
			this.all_product_location = false
			this.model.location_id = []
		},
		onAssignProductLocation() {
			this.product_location_loading = true
			this.errors = new Errors()
			this.$store
				.dispatch('product/location/assignMultipleWarehouse', this.model)
				.then((response) => {
					this.$toasted.success(response.message)
					this.all_product_location = false
					this.fetchData()
				})
				.catch((error) => {
					this.errors = new Errors(error.errors)
					this.product_location_loading = false
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.product_location_loading = false
				})
		},
		fetchLocation() {
			this.loading = true
			this.getLocation().finally(() => {
				this.loading = false
			})
		},
		checkAllLocation(e) {
			if (e) {
				this.model.location_id = this.locationList.map(el => el.value)
			} else {
				this.model.location_id = []
			}

		},
		getGroup() {
			if (this.categoryId !== undefined) {
				this.$store.dispatch('product/location/getGroup')
					.then(response => {
						this.groups = response.data.map(el => ({
							value: el.pro_group_id,
							label: el.pro_group_name_en
						}))
					})
			}
			this.fetchData()
		},
		deleteRecord(record) {
			record._deleting = true
			this.$store
				.dispatch('product/location/destroy', record.product_location_id)
				.then(response => {
					this.$toasted.success(response.message)
					this.fetchData()
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					record._deleting = false
				})
		}
	},
	watch: {
		search: debounce(function (search) {
			this.fetchData()
		}, 500),
		branch_id: debounce(function () {
			this.fetchData()
		}, 500)
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit('product/location/RESET_STATE')
		next()
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.fetchData()
			vm.fetchLocation()
		})
	},
}
</script>
